module.exports = __webpack_public_path__ + "static/img/564_phase_function_Paper_PointsHejduk_Prediction.f29e39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/564_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jHCC
// module chunks = 0